import React from 'react'
import Project from '../components/Project'

const Projects = () => {
  return (
    <div className='container mx-auto'><Project/></div>
  )
}

export default Projects